import { useEffect } from 'react';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import i18n from '@/i18n';
import { store } from '@/store/store';
import { useAppSelector } from '@/store/hooks';
import { selectLocale } from '@/store/slices/settings.selectors';
import { AppThemeProvider } from '@/app/AppThemeProvider';
import { AppToastContainer } from '@/components/feedback/AppToastContainer';
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary';
import { AppRoutes } from '@/routes/AppRoutes';
import { registerSessionListeners } from '@/app/session-listener';

registerSessionListeners();

// Redux (persisted to localStorage, like theme/sidebar) stays the single source of
// truth for the active locale; this keeps i18next's runtime language in sync with it.
function I18nSync() {
  const locale = useAppSelector(selectLocale);

  useEffect(() => {
    void i18n.changeLanguage(locale);
  }, [locale]);

  return null;
}

function App() {
  return (
    <Provider store={store}>
      <I18nSync />
      <AppThemeProvider>
        <ErrorBoundary>
          <AppRoutes />
        </ErrorBoundary>
        <AppToastContainer />
      </AppThemeProvider>
    </Provider>
  );
}

export default App;
